import React from "react";
import "./Hero.css";
import { FaGithub, FaLinkedin, FaDownload } from "react-icons/fa";
import profile from "../../assets/images/profile.jpeg";
import resume from "../../assets/resume/Yamuna-Nagireddy.pdf"
import { useNavigate } from "react-router-dom";

const Hero = () => {
   const navigate = useNavigate();
  return (
    <section className="hero">

      <div className="hero-left">

        <p className="hello">👋 Hello, I'm</p>

        <h1>Yamuna Nagireddy</h1>

        <h2>Python Full Stack Developer</h2>

        <p className="hero-text">
          Passionate Frontend Developer with knowledge of React,
          JavaScript, HTML, CSS, Python and MySQL. I enjoy building
          responsive and user-friendly web applications.
        </p>

        <div className="hero-buttons">
          <button className="hire-btn"  onClick={() => navigate("/contact")}>Contact</button>

          <button className="resume-btn">
            <a href={resume} download="Yamuna-Nagireddy.pdf" rel="noreferrer"><FaDownload /></a>
            
            Download Resume
          </button>
        </div>

        <div className="social-icons">
          <a href="https://github.com/" target="_blank" rel="noreferrer">
            <FaGithub />
          </a>

          <a href="https://linkedin.com/" target="_blank" rel="noreferrer">
            <FaLinkedin />
          </a>
        </div>

      </div>

      <div className="hero-right">
        <img src={profile} alt="Profile" />
      </div>

    </section>
  );
};

export default Hero;